import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';
import type { ConditionAttribute } from 'types/helios/templateForms';
import { getStartPos } from 'utils/section/gridUtils';
import { findTemplateSectionIndex } from '../utils/nameUniqueness';

export interface Payload {
  name: string;
  layoutType: LayoutType;
  position: {
    x: number;
    y: number;
  };
  conditions: ConditionAttribute[];
  subTabId?: string | null;
  tabId?: string | null;
}

export const setSectionItemConditions = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { name, layoutType, position, conditions, subTabId, tabId } = payload;
  const sections = state[layoutType].sections;

  const sectionIndex = findTemplateSectionIndex(sections, name, tabId);
  if (sectionIndex === -1) return state;

  const section = sections[sectionIndex];

  const x = position.x;
  const y = position.y;
  const targetSubTab = subTabId ?? null;

  state[layoutType].sections[sectionIndex].items = section.items.map((item) => {
    const itemX = getStartPos(item.x);
    const itemY = getStartPos(item.y);
    const itemSubTab = item.subTabId ?? null;

    if (itemX === x && itemY === y && itemSubTab === targetSubTab) {
      return { ...item, conditionAttributes: conditions };
    }
    return item;
  });
};
